// Shared list-level CSV export — every core list gets an "Export CSV"
// button that dumps the CURRENTLY FILTERED rows (what the operator sees,
// not the whole collection). Columns: [{ key, label, value? (row)=>any }].
export function exportRowsToCsv(filename, rows, columns) {
  const esc = (v) => {
    if (v === null || v === undefined) return '';
    const s = typeof v === 'object' ? JSON.stringify(v) : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const header = columns.map((c) => esc(c.label)).join(',');
  const lines = rows.map((r) =>
    columns.map((c) => esc(c.value ? c.value(r) : r[c.key])).join(','));
  const csv = [header, ...lines].join('\n');
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
